/**
 * @file useFlashNew.js
 * @location src/components/team/useFlashNew.js
 * @role 표에 새로 들어온 task id 를 잠깐 플래시 — 업무 할당 직후 「방금 보낸 일」을 시각 확인.
 *   첫 렌더(마운트)는 플래시 없음. 표시 전용 — 상태 모델 불변.
 */
import { useEffect, useRef, useState } from 'react';

/** @param {{ id: string }[]} tasks @returns {Set<string>} 플래시 중인 task id 집합 */
export function useFlashNew(tasks) {
  const seen = useRef(null);
  const [flash, setFlash] = useState(() => new Set());
  useEffect(() => {
    const ids = new Set(tasks.map(t => t.id));
    if (seen.current === null) { seen.current = ids; return; }
    const fresh = [...ids].filter(id => !seen.current.has(id));
    seen.current = ids;
    if (!fresh.length) return;
    setFlash(prev => new Set([...prev, ...fresh]));
    const timer = setTimeout(() => {
      setFlash(prev => { const n = new Set(prev); fresh.forEach(f => n.delete(f)); return n; });
    }, 1300);
    return () => clearTimeout(timer);
  }, [tasks]);
  return flash;
}
